<script>
import appConfig from "@/app.config";
import axios from 'axios';
import { EventBus } from "@/event-bus";
import VueEasyLightbox from "vue-easy-lightbox";

// 초기세팅
function initialState (){
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    basicInfo: [],
    useEnd: false,
    historyData: {
      idx: 0,
      contents: "",
      year: "",
      pinDate: "", // date형식 YYYY-MM-DD 기준점이 되는 날짜
      start: "", // string형식 YYYY-MM-DD
      end: "", // string형식 YYYY-MM-DD
      linkUrl: "",
      thum: "",
      thisFiles: [], // 이 게시물의 최종 파일 리스트
      tempFiles: [], // 이 게시물의 임시 파일 리스트
      boardFiles: [], // 게시판에서 첨부된 파일 리스트
    },
    uploadingSpinner: false,
    imageSrc: "",
    filelist: [], // 첨부할 때 사용하는 파일 리스트
    visible: false,
    currentIndex: 0,
    lightboximgs: [],
  };
}
export default {
  components: {
    VueEasyLightbox,
  },
  data() {
    return initialState();
  },
  watch: {
  },
  created() {
    // 초기실행
    this.first();
  },
  computed: {
  },
  mounted() {  
  },
  methods: {
    // 초기화
    resetWindow: function (){
      Object.assign(this.$data, initialState());
    },
    // 처음실행
    first: function() {
      this.resetWindow();
      // 사용자 정보 가져오자
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
      // store에서 정보받기
      this.basicInfo = this.$store.getters.getModal_lg
      // 연혁 수정이라면 historyData로 정보 복사하자 (편집가능하게), 게시판에서 연혁추가도 마찬가지
      if (this.basicInfo.worker=="timelineEdit" || this.basicInfo.worker=="boardAdd") {
        // 기본 초기값을 유지하면서, 서버에서 온 값으로 덮어쓰기 (tempFiles, thisFiles 보존)
        this.historyData = Object.assign({}, this.historyData, this.basicInfo.val)
        
        // useEnd 처리해주자
        if (this.historyData.end =='' || this.historyData.end == null) {
          this.useEnd = false
        } else {
          this.useEnd = true
        }
        // historyData안에 useEnd 없애주자
        if (this.historyData.hasOwnProperty('useEnd')) {
          delete this.historyData.useEnd;
        }
        // tempFiles / thisFiles / boardFiles안전하게 초기화 (없으면 빈 배열)
        if (!Array.isArray(this.historyData.tempFiles)) {
          this.historyData.tempFiles = [];
        }
        if (!Array.isArray(this.historyData.thisFiles)) {
          this.historyData.thisFiles = [];
        }
        if (!Array.isArray(this.historyData.boardFiles)) {
          this.historyData.boardFiles = [];
        }
      }
      // 오늘 날짜를 YYYY-MM-DD 형식으로 포맷하여 historyData.start에 할당
      if (this.historyData.start == null || this.historyData.start == '') {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; // "YYYY-MM-DD" 형식
        this.historyData.start = formattedDate;
      }
    },
    // 닫기
    hide() {
      this.$store.commit('setModal_lgVal', ''); // store.js 로 닫히니까 정리해주자
      this.$store.commit('setModal_lgWorker', ''); // store.js 로 닫히니까 정리해주자
      this.$bvModal.hide('modal_lg');
      // 닫을 때 연혁쪽 리플레쉬 하자
      EventBus.$emit("menu-timeline", "listRefresh");
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-success')) {
        event.currentTarget.classList.remove('bg-light');
        event.currentTarget.classList.add('bg-success');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add('bg-light');
      event.currentTarget.classList.remove('bg-success');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.fileSinput.files = event.dataTransfer.files;
      this.handleFileUpload();
      event.currentTarget.classList.add('bg-light');
      event.currentTarget.classList.remove('bg-success');
    },
    async handleFileUpload() {
      this.filelist = [...this.$refs.fileSinput.files];
      if (this.filelist) {
        // 파일명 기준으로 재정렬시키자
        this.filelist.sort(function(a, b) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });
        const formData = new FormData();
        for (let i = 0; i < this.filelist.length; i++) {
          formData.append('files', this.filelist[i]);  // 'files'와 FastAPI의 필드 이름이 일치해야 합니다.
        }
        formData.append('historyIdx', this.historyData.idx); // 연혁idx도 폼데이터에 같이 넣어주자
        //spin 이미지 띄우자
        this.uploadingSpinner = true;
        this.loadingBar(true)
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/history/history_image_upload',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.data.status == 'success') {
            if (response.data.files) {
              // 반복문
              response.data.files.forEach((item) => {
                // 첨부파일 리스트에 담자
                const temp = {
                  'tempUrl': item.tempUrl,
                  'name': item.name,
                  'ext': item.ext,
                  'url':appConfig.fileserver + item.tempUrl,
                }
                this.historyData.tempFiles.push(temp)
              });
            }
          } else {
            this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '관리자에게 문의해주세요'})
          }
          // spin 이미지 닫자
          this.uploadingSpinner = false;
          // 업로드시킬 파일리스트는 초기화
          this.filelist = [];
          this.imageSrc = '';
          this.$refs.fileSinput.value=null;
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          // 스핀 이미지 닫자
          this.uploadingSpinner = false;
          this.loadingBar(false)
        })
      }
    },
    async fileDelete(val1, val2, index) {
      // val1 : tempFiles (업로드파일리스트), thisFiles (기존파일리스트)
      // val2 : 파일명 ex) 202406211250312a8b08bd.png
      if (val2) {
        this.loadingBar(true)
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/history/history_image_delete',
          data: {
            "valueType": val1,
            "valueName": val2,
            "historyIdx": this.historyData.idx,
          },
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
            // 리스트에서도 삭제반영해주자
            if (val1=='tempFiles') {
              this.historyData.tempFiles.splice(index, 1);
            } else if (val1=='thisFiles') {
              this.historyData.thisFiles.splice(index, 1);
            }
          } else {
            this.$notify({ type: 'success', duration:2000, 'title': '실패', text: response.data.message})
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loadingBar(false)
        })
      }
    },
    /*
    insertImage() {
      // 쿼리 문자열을 제거한 이미지 URL 생성
      const cleanImageSrc = this.imageSrc.split('?')[0];
      this.editor.chain().focus().setImage({ src: cleanImageSrc }).run()
    },
    */
    // // YYYY-MM-DD 또는 YYYY-MM 형식에 맞는지
    isValidDateFormat(date) {
      // YYYY-MM-DD 형식에 맞는 정규식
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      if (regex.test(date)) {
        return true;
      } else {
        // YYYY-MM 형식에 맞는 정규식
        const regex = /^\d{4}-\d{2}$/;
        return regex.test(date);
      }
    },
    // 날짜포멧
    formatDate(val1, event) {
      let value = event.target.value.replace(/[^0-9]/g, ''); // 숫자만 추출
        
        // 자리 제한 (8자리)
        if (value.length > 8) {
          value = value.substring(0, 8);
        }
        
        // 하이픈 추가 (ex: 20250225 -> 2025-02-25)
        if (value.length > 4) {
          value = value.substring(0, 4) + '-' + value.substring(4);
        }
        if (value.length > 7) {
          value = value.substring(0, 7) + '-' + value.substring(7);
        }
        if (val1 == 'start') {
          this.historyData.start = value;
        } else if (val1 == 'end') {
          this.historyData.end = value;
        }
        event.target.value = value;
    },
    async sendHistoryData() {
      if (this.historyData.contents=="" || this.historyData.start=="" || this.historyData.start==null) {
        this.$notify({ type: 'error', duration:3000, 'title': '실패', text: "내용과 시작일자는 필수사항입니다."})
      } else {
        // 날짜 형식이 올바른지 확인
        if (this.isValidDateFormat(this.historyData.start)) {
          this.loadingBar(true)
          // start 값에서 연도 추출
          this.historyData.year = this.historyData.start.split('-')[0];
          // useEnd가 false라면 end 날짜 빈값으로 만들어버리자
          if (this.useEnd==false) {
            this.historyData.end = ''
          }
          // pinDate는 start 값으로 할당해주자 start가 일자가 빠져있으면 일자부분은 01로 넣자 
          // (date형식 YYYY-MM-01)
          if (this.historyData.start.split('-').length == 2) { // YYYY-MM 형식일 때
            this.historyData.pinDate = this.historyData.start + '-01'; // YYYY-MM-01 형식으로 할당
          } else { // YYYY-MM-DD 형식일 때
            this.historyData.pinDate = this.historyData.start;
          }
          await axios({
            method: 'POST',
            url: appConfig.fastapi + '/history/sendHistoryData',
            data: {
              "work": this.basicInfo.worker,
              "historyData": this.historyData,
            },
          })
          .then((response) => {
            if (response.data.type) {
              if (response.data.type=='success') {
                this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
              } else {
                this.$notify({ type: 'error', duration:2000, 'title': '실패', text: response.data.message})
              }
            } else {
              this.$notify({ type: 'error', duration:2000, 'title': '실패', text: response.data})
            }
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            // menu-timeline.vue 에서 연혁 리스트 새로고침
            EventBus.$emit("menu-timeline", "listRefresh");
            this.loadingBar(false)
          })
        } else {
          // 날짜 형식이 올바르지 않은 경우 경고 출력
          this.$notify({ type: 'error', duration:3000, 'title': '실패', text: "날짜형식은 YYYY-MM-DD 또는 YYYY-MM형식이어야 합니다. ("+this.historyData.start+")"})
        }
      }
    },
    imgThum(val1, val2) {
      if (val1 == 'thumb') {
        return appConfig.fileserver+"/historyThum/"+val2;
      } else {
        return appConfig.fileserver+"/historyImages/"+val2;
      }
    },
    imgThumClick(file_json, index) {
      this.lightboximgs = this.getOriginalImageUrl(file_json);
      this.currentIndex = index;
      this.visible = true;
    },
    getOriginalImageUrl(file_json) {
      return file_json.map(item => appConfig.fileserver+"/historyImages/"+item);
    },
    deleteHistoryData() {
      // 사용자에게 삭제 여부를 묻는 confirm 창을 띄웁니다.
      const result = window.confirm("이 연혁을 정말 삭제하시겠어요?");
      if (result) {
        // 사용자가 "예"를 선택했을 때 실행할 코드
        this.sendhistoryDelete();
      }
    },
    async sendhistoryDelete() {
      this.loadingBar(true)
      await axios({
        method: 'POST',
        url: appConfig.fastapi + '/history/sendhistoryDelete',
        headers: {
          "access-token": this.token,
          "login-idx": this.login.idx,
        },
        data: {
          "idx": this.historyData.idx,
        },
      })
      .then((response) => {
        if (response.data.status) {
          if (response.data.status=='success') {
            this.$notify({ status: 'success', duration:2000, 'title': '성공', text: response.data.text})
            // 연혁 삭제되었으니 모달 닫아주자
            this.hide()
          } else {
            this.$notify({ status: 'error', duration:2000, 'title': '실패', text: response.data.text})
          }
        } else {
          this.$notify({ status: 'error', duration:2000, 'title': '실패', text: response.data})
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        this.loadingBar(false)
      })
    },
    // 기다려주세요 loading 처리
    loadingBar(val) {
      this.$nextTick(() => {
        const preloader = document.getElementById("preloader");
        const status = document.getElementById("status");
        
        if (preloader && status) {
          if (val === true) {
            preloader.style.display = "block";
            status.style.display = "block";
          } else {
            preloader.style.display = "none";
            status.style.display = "none";
          }
        }
      });
    },
    // file_json에서 썸네일용 이미지 리스트 뽑아오기
    thumbListFromFileJson(fileJson) {
      if (!fileJson) return [];

      let data = fileJson;
      // 문자열로 넘어오면 JSON 파싱 시도
      if (typeof fileJson === 'string') {
        try {
          data = JSON.parse(fileJson);
        } catch (e) {
          return [];
        }
      }

      if (!Array.isArray(data)) return [];

      // [{ file: "...", ... }] 형태일 때 (파일명 필드 사용)
      if (data.length && typeof data[0] === 'object') {
        return data
          .filter(f => f && (f.file || f.url))
          .map(f => f.file || f.url);
      }

      // ["...", "..."] 문자열 배열일 때 (파일명 배열 그대로)
      return data;
    },
  }, // methods 종료
  middleware: "authentication",
};
</script>

<template>
  <div v-if="basicInfo.worker=='timelineAdd' || basicInfo.worker=='timelineEdit' || basicInfo.worker=='boardAdd'" class="row">
    <!-- 이미지 크게 -->
    <vue-easy-lightbox :visible="visible" :index="currentIndex" :imgs="lightboximgs" scrollDisabled='false' @hide="visible = false"></vue-easy-lightbox>
    <div class="col-xl-12">
      <div class="border-bottom p-1 mb-2">
        <div class="p-0">
          <div class="media align-items-center">
            <div class="media-body overflow-hidden">
              <div v-if="basicInfo.worker=='timelineAdd'" class="h4">
                <span class="text-blue">
                  <i class="mdi mdi-book-edit"></i>
                  연혁 추가
                </span>
              </div>
              <div v-if="basicInfo.worker=='boardAdd'" class="h4">
                <span class="text-blue">
                  <i class="mdi mdi-book-edit"></i>
                  게시판에서 연혁추가
                </span>
              </div>
              <div v-if="basicInfo.worker=='timelineEdit'" class="h4">
                <span class="text-primary">
                  <i class="mdi mdi-playlist-edit"></i>
                  연혁 수정
                </span>
              </div>
            </div>
            <a class="" href="javascript:void(0);" @click="hide">
              <div class="btn btn-block p-0">
                <i class="mdi mdi-close display-6 text-secondary"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 본문 -->
    <div v-if="basicInfo.worker" class="col-xl-12 mt-2 mb-2">
      <div class="col-lg-12">
        <div class="row">

          <div class="col-md-12 mb-2">
            <div class="p-1 bg-soft-secondary rounded text-dark text-bold font-size-11">
              <span class="text-danger">*일자 지정 규칙</span> <br />
              시작일자만 입력시  <b class="text-blue ml-2">2024-08-13</b> <br />
              종료일자도 입력시  <b class="text-blue ml-2">2024-08-13 ~ 2024-08-31</b> <br />
              시작일자와 종료일자 똑같다면  <b class="text-blue ml-2">2024-08-13 ~</b> <br />
              일자 빼고도 기입가능  <b class="text-blue ml-2">2024-08</b> <br />
            </div>
          </div>

          <div class="col-xl-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="title" class="font-size-12">내용 <span class="text-danger">*</span></label>
              <div class="position-relative">
                <!-- 최대 200자 까지만 입력가능하게 -->
                <input type="text" v-model="historyData.contents" class="form-control pl-3" placeholder="내용을 채워주세요" name="title" maxlength="200" />
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="start" class="font-size-12">시작일자 <span class="text-danger">*</span></label>
              <div class="position-relative">
                <input type="text" @input="formatDate('start', $event)" v-model="historyData.start" class="form-control pl-3" placeholder="" name="start" />
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-12 col-sm-12">
            <div class="form-group mb-0">
              <label for="useEnd" class="font-size-12">종료사용</label>
              <div class="custom-control custom-switch">
                <input
                  v-model="useEnd"
                  type="checkbox"
                  class="custom-control-input"
                  id="useEnd"
                />
                <label class="custom-control-label text-secondary font-size-12" for="useEnd">
                  종료일자 지정하게
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-12 col-sm-12">
            <div v-if="useEnd==true" class="form-group">
              <label for="end" class="font-size-12">종료일자</label>
              <div class="position-relative">
                <input type="text" @input="formatDate('end', $event)" v-model="historyData.end" class="form-control pl-3" placeholder="" name="end" />
              </div>
            </div>
          </div>
          <!-- 새연혁추가의 이미지 파일첨부 -->
          <div v-if="basicInfo.worker=='timelineAdd' || basicInfo.worker=='boardAdd'" class="col-xl-6 col-md-12 col-sm-12">
            <div class="form-group">
              <span class="font-size-12 font-weight-bold">이미지 파일첨부</span>
              <div v-if="basicInfo.worker=='timelineAdd'" class="">
                <label for="FieldfileS" class="p-0 mt-2 mb-2 col-12">
                  <div class="ed-clickable text-center bg-light" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <div class="mt-4" v-if="uploadingSpinner === true">
                      <b-spinner class="display-5 text-success" label="Loading"></b-spinner>
                      <h6 class="text-info">업로드중이니 기다려주세요...</h6>
                    </div>
                    <div class="" v-if="uploadingSpinner === false">
                      <i class="display-5 text-primary mdi mdi-file-upload-outline"></i>
                      <h6 class="">클릭 or 끌어서넣기</h6>
                    </div>
                  </div>
                </label>
                <input type="file" multiple name="fields[FieldfileS][]" id="FieldfileS" class="w-px h-px overflow-hidden" @change="handleFileUpload" ref="fileSinput" accept=".jpg,.jpeg,.png,.gif" />
              </div>
              <div v-else class="text-center font-size-12">게시판에서 연혁추가 할 때는 게시판의 첨부파일을 사용합니다.</div>
              <div v-if="historyData.tempFiles">
                <div v-if="historyData.tempFiles.length > 0" class="">
                  <span class="font-size-13 text-bold">업로드 첨부파일 리스트</span>
                  <div class="row h-100 mx-1">
                    <b-list-group horizontal v-for="(value, key) in historyData.tempFiles" :key="key" class="mr-1 mb-1">
                      <div class="">
                        <div v-if="value.ext=='.jpg' || value.ext=='.jpeg' || value.ext=='.png' || value.ext=='.gif'" class="border-top border-left border-right" v-b-tooltip.hover :title="value.name">
                          <img :src="value.url" class="p-1" width="65" height="65" loading="lazy" />
                        </div>
                        <div v-else class="border" v-b-tooltip.hover :title="value.name">
                          <div class="avatar avatar-small avatar-tiny mx-auto d-block text-center">
                            <div class="font-size-13 text-blue">{{ fileExtensionCheck(value.name) }}</div>
                            <div class="font-size-12">일반파일</div>
                          </div>
                        </div>
                        <div @click="fileDelete('tempFiles', value.name, key)" class="bg-soft-danger text-center font-size-11 cursor-pointers">
                          삭제
                        </div>
                      </div>
                    </b-list-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 기존연혁 편집의 이미지 파일첨부 / 썸네일 교체 -->
          <div v-if="basicInfo.worker=='timelineEdit'" class="col-xl-6 col-md-12 col-sm-12">
            <!-- 새 이미지 파일 업로드 -->
            <div class="form-group">
              <span class="font-size-12 font-weight-bold">새 이미지 파일첨부 (기존 이미지들은 모두 삭제됩니다.)</span>
              <div class="">
                <label for="FieldfileS" class="p-0 mt-2 mb-2 col-12">
                  <div class="ed-clickable text-center bg-light" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <div class="mt-4" v-if="uploadingSpinner === true">
                      <b-spinner class="display-5 text-success" label="Loading"></b-spinner>
                      <h6 class="text-info">업로드중이니 기다려주세요...</h6>
                    </div>
                    <div class="" v-if="uploadingSpinner === false">
                      <i class="display-5 text-primary mdi mdi-file-upload-outline"></i>
                      <h6 class="">클릭 or 끌어서넣기</h6>
                    </div>
                  </div>
                </label>
                <input
                  type="file"
                  multiple
                  name="fields[FieldfileS][]"
                  id="FieldfileS"
                  class="w-px h-px overflow-hidden"
                  @change="handleFileUpload"
                  ref="fileSinput"
                  accept=".jpg,.jpeg,.png,.gif"
                />
              </div>
              <!-- 새로 업로드한 파일 리스트 -->
              <div v-if="historyData.tempFiles">
                <div v-if="historyData.tempFiles.length > 0" class="">
                  <span class="font-size-13 text-bold">업로드 첨부파일 리스트</span>
                  <div class="row h-100 mx-1">
                    <b-list-group
                      horizontal
                      v-for="(value, key) in historyData.tempFiles"
                      :key="key"
                      class="mr-1 mb-1"
                    >
                      <div class="">
                        <div
                          v-if="value.ext=='.jpg' || value.ext=='.jpeg' || value.ext=='.png' || value.ext=='.gif'"
                          class="border-top border-left border-right"
                          v-b-tooltip.hover
                          :title="value.name"
                        >
                          <img :src="value.url" class="p-1" width="65" height="65" loading="lazy" />
                        </div>
                        <div v-else class="border" v-b-tooltip.hover :title="value.name">
                          <div class="avatar avatar-small avatar-tiny mx-auto d-block text-center">
                            <div class="font-size-13 text-blue">{{ fileExtensionCheck(value.name) }}</div>
                            <div class="font-size-12">일반파일</div>
                          </div>
                        </div>
                        <div
                          @click="fileDelete('tempFiles', value.name, key)"
                          class="bg-soft-danger text-center font-size-11 cursor-pointers"
                        >
                          삭제
                        </div>
                      </div>
                    </b-list-group>
                  </div>
                </div>
              </div>
            </div>


            <!-- 썸네일 이미지 있으면 (file_json 기준으로 여러 개 겹쳐서 표시) -->
            <div v-if="thumbListFromFileJson(historyData.file_json).length > 0" class="work-container work-modern position-relative d-block overflow-hidden">
              <label for="beforeThum2" class="font-size-12 font-weight-bold">기존에 첨부된 이미지</label>
              <div class="position-relative">
                <div id="beforeThum1" class="history-thum rounded text-center">
                  <div
                    v-for="(thumb, index) in thumbListFromFileJson(historyData.file_json)"
                    :key="index"
                    class="history-thum-item cursor-pointers"
                    @click="imgThumClick(historyData.file_json, index)"
                    :style="{ left: (index * 16) + 'px', zIndex: (10 - index) }"
                  >
                    <img
                      :src="imgThum('thumb', thumb)"
                      class="avatar avatar-small avatar-tiny rounded-circle shadow d-block mx-auto border-2"
                      alt="history thumbnail"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- file_json 없는데 thum 있으면 -->
            <div v-else-if="historyData.thum" class="work-container work-modern position-relative d-block overflow-hidden">
              <label for="beforeThum2" class="font-size-12 font-weight-bold">기존에 첨부된 이미지</label>
              <div class="position-relative">
                <div id="beforeThum2"class="history-thum rounded text-center">
                  <img
                    :src="imgThum('thumb', historyData.thum)"
                    class="avatar avatar-small avatar-tiny shadow d-block mx-auto border-2"
                    alt="history thumbnail"
                  />
                </div>
              </div>
            </div>

            <!-- file_json 없는데  thum도 없으면 -->
            <div v-else class="work-container work-modern position-relative d-block overflow-hidden">
              <span class="font-size-12 font-weight-bold">기존에 첨부된 이미지가 없습니다.</span>
              <div class="history-thum rounded text-center">
              </div>
            </div>

          </div>
          
          <div class="col-xl-6 col-md-12 col-sm-12">
            <div class="form-group">
              <label for="linkUrl" class="font-size-12">링크주소</label>
              <div class="position-relative">
                <!-- 최대 200자 까지만 입력가능하게 -->
                <input type="text" v-model="historyData.linkUrl" class="form-control pl-3" placeholder="클릭시 새창으로 열릴 url주소" name="linkUrl" maxlength="200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
          
    <!-- 저장 -->
    <div class="col-xl-12 mt-2 mb-2">
      <div v-if="basicInfo.worker=='timelineAdd' || basicInfo.worker=='boardAdd'" class="row">
        <div class="col-xl-12">
          <b-button @click="sendHistoryData()" class="btn btn-md btn-block btn-soft-blue text-bold">
            <i class="mdi mdi-content-save me-1"></i>
            저장
          </b-button>
        </div>
      </div>
      <div v-if="basicInfo.worker=='timelineEdit'" class="row">
        <div class="col-xl-9 mb-2">
          <b-button @click="sendHistoryData()" class="btn btn-md btn-block btn-primary text-bold">
            <i class="mdi mdi-content-save me-1"></i>
            저장
          </b-button>
        </div>
        <div class="col-xl-3 mb-2">
          <b-button @click="deleteHistoryData()" class="btn btn-md btn-block btn-danger text-bold">
            <i class="mdi mdi-content-save me-1"></i>
            삭제
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
